export default __webpack_public_path__ + "static/media/time_black.b34737c8.svg";